export enum MLResultType {
  DID_YOU_MEAN = 'DYM',
  FUZZY = 'FUZ',
  LANDING_PAGE = 'LPG',
  MY_STORE_ZERO = 'MSZ',
  NORMAL = 'NRM',
  PRICE_FILTER_ZERO = 'PFZ',
}
